
import React from 'react';
import DynamicEditForm from '../../components/DynamicEditForm/DynamicEditForm.js'; // Import your form component
import {getStoredData} from "../../JsonFiles/fetchData";

const EditProjectsPage = () => {
  const fields = getStoredData()?.["11"]?.AdminProjects ?? {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/projects'; // API URL for fetching/editing product
  const successRedirect = '/admin/projects'; 
  console.log(apiUrl);

  return (
    <div>
      <DynamicEditForm
        fields={fields}
        apiUrl={apiUrl}
        successRedirect={successRedirect}
      />
    </div>
  );
};

export default EditProjectsPage